export default __webpack_public_path__ + "assets/icon-groups-green.abe80f49.webp";